<div class="side-menu-shell">
    <div class="side-menu-shell-header">
        <ng-content select="upp-side-menu-header"></ng-content>
    </div>
    <div class="side-menu-shell-content">
        <ng-content select="upp-side-menu-content"></ng-content>
    </div>
</div>
